<div class="dialog-container">
  <mat-card-title>
    Sharing options
  </mat-card-title>
  <mat-card-subtitle>
    Who can view this {{ hubMode | courseLabel }}? <mat-icon (click)="openSharingHelp()"  matTooltip="Open Help Center" matTooltipShowDelay="500">help</mat-icon>
  </mat-card-subtitle>
      <mat-radio-group id="sharing-options" [ngModel]="status" (change)="onSharingChange($event)">
          <mat-radio-button value="private">
            <span class="option-title">Private :</span> <span> Only people with the link who belong to my organization </span>
          </mat-radio-button>
          <mat-radio-button value="open">
            <span class="option-title">Open :</span> <span> Everyone with the Link</span>
          </mat-radio-button>
      </mat-radio-group>
  <mat-divider class="divider"></mat-divider>
  <div *ngIf="!course.is_multi; else multiLinks">
    <div class="url-container">
      <span id="url-container-title"><mat-icon>link</mat-icon>Direct Link</span>
      <input type="text" [value]="presenterLink" readonly (click)="$event.target.select()">
      <mat-icon *ngIf="presenterLink" (click)="launchInNewTab(presenterLink)">launch</mat-icon>
      <mat-icon (click)="copy($event)">content_copy</mat-icon>
      <div class="shortcode" *ngIf="presenterShortCode" [matTooltip]="presenterTooltipMessage"><mat-icon svgIcon="cardboard"></mat-icon> {{ presenterShortCode }}</div>
    </div>
    <div class="url-container">
      <span id="url-container-title"><mat-icon>code</mat-icon>Embed code</span>
      <textarea rows="4" type="text" name="url" [value]="embedcode" readonly (click)="$event.target.select()"></textarea>
      <mat-icon (click)="copy($event)">content_copy</mat-icon>
    </div>
  </div>
  <ng-container [ngTemplateOutlet]="versioningSharing" *ngIf="hubMode === 'space'">
  </ng-container>
    <!-- <div *ngIf="shortCodeDomain">
      Open <a [href]="'//' + shortCodeDomain">{{ shortCodeDomain }}</a> and enter the code below for quick VR access
    </div> -->

    <!-- <div>
        <mat-icon style="font-size: 20px">save_alt</mat-icon>
        <span style="font-weight:bold; margin-left: 4px;"> Download</span> this experience for desktop <span>(Soon available)</span>
    </div> -->
</div>

<ng-template #multiLinks>
  <mat-card-subtitle>
    Share the right link according to user's roles <mat-icon (click)="openRolesHelp()"  matTooltip="Open Help Center" matTooltipShowDelay="500">help</mat-icon>
  </mat-card-subtitle>
  <div class="url-container">
    <span id="url-container-title"><mat-icon class="svg-icon" svgIcon="icon-action-link"></mat-icon>Presenter</span>
    <input type="text" [value]="presenterLink" readonly (click)="$event.target.select()">
    <mat-icon (click)="copy($event)">content_copy</mat-icon>
    <div *ngIf="presenterShortCode" class="shortcode" [matTooltip]="presenterTooltipMessage"><mat-icon svgIcon="cardboard"></mat-icon> {{ presenterShortCode }}</div>
  </div>
  <!-- Learner URL == Solo URL -->
  <div class="url-container">
    <span id="url-container-title"><mat-icon class="svg-icon" svgIcon="icon-action-link"></mat-icon>Learner</span>
    <input type="text" [value]="learnerLink" readonly (click)="$event.target.select()">
    <mat-icon (click)="copy($event)">content_copy</mat-icon>
    <div *ngIf="learnerShortCode" class="shortcode" [matTooltip]="learnerTooltipMessage"><mat-icon svgIcon="cardboard"></mat-icon> {{ learnerShortCode }}</div>
  </div>
</ng-template>

<ng-template #versioningSharing>
  <mat-divider class="divider"></mat-divider>
  <mat-card-subtitle>
    Advanced Publishing Options
  </mat-card-subtitle>
  <div id="enable-versioning-container">
    <mat-checkbox
            class="checkbox first-checkbox"
            [disabled]="!isVersioningAvailable()"
            [ngModel]="isVersioningAvailable() && course.information.versioningEnabled"
            (change)="onVersioningChange($event)"
            [matTooltip]="getVersioningTooltipMessage()"
    >
      <span class="enable-versioning">
       Enable Versioning </span>
    </mat-checkbox>
    <div class="enable-versioning help-icon">
      <mat-icon matTooltip="Open Help Center" (click)="blockEventAndOpenVersioningHelp($event)" class="help-link">help</mat-icon>
    </div>
  </div>
  <div *ngIf="isVersioningAvailable() && course?.information?.versioningEnabled" id="versioning-container">
    <div>
      <span>Latest version: </span><span><b [ngClass]="{'highlighted-version': _hasSuccessfullyPublished}">{{courseLatestRelease ? courseLatestRelease.version : 'None'}}</b> {{ courseLatestRelease ? (courseLatestRelease.createdAt | date: 'MM/dd/yy')  : ''}}</span>
    </div>
    <div>
      <button *ngIf="courseLatestRelease" mat-raised-button  [matTooltip]="'Push new version to all users'" [disabled]="!canPublishAndReset()" color="secondary" id="publish-and-reset" (click)="onPublishAndReset()">Publish & Reset</button>
      <button mat-raised-button color="primary" id="publish" [matTooltip]="'Publish to new users'" [disabled]="!canPublish()" (click)="onPublish()">Publish</button>
    </div>
  </div>
</ng-template>